export const getStrNumMode = (): { [key: number]: string } => {
  return {
    0: "Дублировать основной номер",
    1: "Следующее значение от генератора номеров",
    2: "Сквозная нумерация в разрезе учреждений",
    3: "Сквозная нумерация без учета учреждений",
    4: "Генератор номеров для каждого учреждения",
  };
};

export const getStrNumModeList = () => {
  return [
    { label: "Дублировать основной номер", id: 0 },
    { label: "Следующее значение от генератора номеров", id: 1 },
    { label: "Сквозная нумерация в разрезе учреждений", id: 2 },
    { label: "Сквозная нумерация без учета учреждений", id: 3 },
    { label: "Генератор номеров для каждого учреждения", id: 4 },
  ];
};

export const getNewNumMode = (): { [key: number]: string } => {
  return {
    0: "Следующее значение от генератора номеров",
    1: "Сквозная нумерация в разрезе учреждений",
    2: "Сквозная нумерация без учета учреждений",
    3: "Генератор номеров для каждого учреждения",
  };
};

export const getNewNumModeList = () => {
  return [
    { label: "Следующее значение от генератора номеров", id: 0 },
    { label: "Сквозная нумерация в разрезе учреждений", id: 1 },
    { label: "Сквозная нумерация без учета учреждений", id: 2 },
    { label: "Генератор номеров для каждого учреждения", id: 3 },
  ];
};

export const getRangeList = (generationkey: string) => {
  if (
    generationkey === "Сквозная нумерация в разрезе учреждений" ||
    generationkey === "Сквозная нумерация без учета учреждений"
  ) {
    return [
      { label: "Никогда", id: -17 },
      { label: "Каждый месяц", id: -1 },
      { label: "Каждый квартал", id: -2 },
      { label: "Каждый год", id: -3 },
      { label: "От установленного номера", id: -4 },
    ];
  }
  return [
    { label: "Никогда", id: 0 },
    { label: "Каждый месяц", id: 1 },
    { label: "Каждый квартал", id: 2 },
    { label: "Каждый год", id: 3 },
    { label: "До установленного номера", id: 4 },
  ];
};

export const getNegativeID = (id: number) => {
  if (id < 0) return id;
  const idMap: { [key: number]: number } = {
    0: -17,
    1: -1,
    2: -2,
    3: -3,
    4: -4,
  };
  return idMap[id];
};

export const getPositiveID = (id: number) => {
  if (id >= 0) return id;
  const idMap: { [key: number]: number } = {
    [-17]: 0,
    [-1]: 1,
    [-2]: 2,
    [-3]: 3,
    [-4]: 4,
  };
  return idMap[id];
};

export const getRange = (): { [key: number]: string } => {
  return {
    [-17]: "Никогда",
    [-1]: "Каждый месяц",
    [-2]: "Каждый квартал",
    [-3]: "Каждый год",
    [-4]: "От установленного номера",
    0: "Никогда",
    1: "Каждый месяц",
    2: "Каждый квартал",
    3: "Каждый год",
    4: "До установленного номера",
  };
};

export const getAssignMode = (): { [key: number]: string } => {
  return {
    0: "При создании документа",
    1: "При сохранении документа",
    2: "При создании с коррекцией при сохранении",
  };
};

export const getAssignModeList = () => {
  return [
    { label: "При создании документа", id: 0 },
    { label: "При сохранении документа", id: 1 },
    { label: "При создании с коррекцией при сохранении", id: 2 },
  ];
};
